// extracted by mini-css-extract-plugin
export default {"container":"MenuButton_container__XXhiv","wrapper":"MenuButton_wrapper__6tys3"};